export default {"src":"/_next/static/media/ico-audio.142be6e4.svg","height":34,"width":40,"blurWidth":0,"blurHeight":0};